import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BillingPlansDataModule } from '@recruitee/billing-plans/data';

@NgModule({
  imports: [CommonModule, BillingPlansDataModule],
})
export class BillingPlansModule {}
